module.exports = __webpack_public_path__ + "img/01.dd8e1696.jpg";